
import $ from "jquery";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Mutation, State } from "vuex-class";

import FlagIcon from "@/components/icons/FlagIcon.vue";

import {
  CANDIDAT_SIGNUP,
  CANDIDAT_SIGNIN,
  SCHOOL_SIGNUP,
  SCHOOL_SIGNIN,
  COMPANY_SIGNUP,
  COMPANY_SIGNIN,
} from "@/constants/portal.constant";

@Component({
  components: {
    FlagIcon,
  },
})
export default class NavbarComponent extends Vue {
  /* VUEX */

  // MUTATION
  @Mutation("mutationLocale")
  private mutationLocale: any;

  // STATE
  @State("locale")
  private locale!: string;

  /* PROP */

  @Prop({ default: false })
  private logoColor!: boolean;
  @Prop({ default: "#" })
  private loginLink!: string;
  @Prop({ default: "#" })
  private signupLink!: string;
  @Prop({ default: "Daftar" })
  private wordingSignUp!: string;
  @Prop({ default: true })
  private showAuth!: boolean;

  /* INITIALIZATION */

  private candidateSignup: string = CANDIDAT_SIGNUP;
  private candidateSignin: string = CANDIDAT_SIGNIN;

  private schoolSignup: string = SCHOOL_SIGNUP;
  private schoolSignin: string = SCHOOL_SIGNIN;

  private companySignup: string = COMPANY_SIGNUP;
  private companySignin: string = COMPANY_SIGNIN;

  constructor() {
    super();
  }

  /* COMPUTED */

  get flag(): string {
    return this.locale === "en" ? "us" : "id";
  }

  /* LIFECYCLE */

  private created() {
    this.$i18n.locale = this.locale;
  }

  /* METHOD */

  private checkMenuActive(menu: string[]): boolean {
    if (document.getElementById("checkboxNavToggle") as any) {
      (document.getElementById("checkboxNavToggle") as any).checked = false;
    }
    return menu.includes(String(this.$route.name));
  }

  private changeLanguage(lang: string) {
    this.mutationLocale(lang);
    this.$i18n.locale = lang;
  }

  private navbarToggler() {
    const $navbar = $(".main-nav");
    $navbar.toggleClass("navbar-expanded");
  }
}
